import { CardContent } from "@mui/material";
import styled from "styled-components/macro";
import {
  BREAKPOINT_TABLET,
  FONT_SIZE_LARGE,
} from "../../../constants/constants";
import { getMetricExplainers } from "./metricExplainerUtils";
import MetricExplainerRow from "./MetricExplainerRow";
import { MetricExplainerInputType } from "./metricExplainerTypes";

const MetricExplainerContent = styled.div`
  .cardContent {
    padding: 50px 100px;
  }

  .metricExplanationTitle {
    padding-bottom: 0.5em;
    font-size: ${FONT_SIZE_LARGE}px;
    font-weight: 700;
    line-height: ${FONT_SIZE_LARGE}px;
  }

  &&& {
    @media print {
      margin: 0 auto;
      .cardContent {
        padding: 50px;
      }
      .metricExplanationTitle {
        font-size: ${FONT_SIZE_LARGE}px;
        font-weight: 700;
        line-height: ${FONT_SIZE_LARGE}px;
      }
    }
  }

  @media (max-width: ${BREAKPOINT_TABLET}px) {
    .cardContent {
      padding: 20px;
    }

    .metricExplanationTitle {
      font-size: ${FONT_SIZE_LARGE - 2}px;
      line-height: ${FONT_SIZE_LARGE - 2}px;
    }
  }
`;

export default function MetricExplainer({
  metricsExplainer,
}: {
  metricsExplainer: MetricExplainerInputType[];
}) {
  const metricExplainerObjects = getMetricExplainers(metricsExplainer);

  return (
    <MetricExplainerContent>
      <CardContent className="cardContent">
        <div className="metricExplanationTitle">Metric Explanations</div>
        {metricExplainerObjects.map(metricObject => (
          <MetricExplainerRow key={metricObject.name} {...metricObject} />
        ))}
      </CardContent>
    </MetricExplainerContent>
  );
}
